module.exports = "<app-data-table [(itemType)]=\"DTTM\" [rowsPerPage]=\"6\" [dataSource]=\"dettagli\"></app-data-table>"